export const freehand = {
  visible: true,
  active: false,
  invalidated: true,
  handles: {
    points: [],
    textBox: {},
    invalidHandlePlacement: false,
  },
  canComplete: false,
  highlight: false,
};
